<template>
  <div>
    <div class="text--secondary mb-3">Insira imagens dos danos</div>

    <!-- LISTA (INLINE EDIT) -->
    <v-row dense v-if="items.length">
      <v-col v-for="item in items" :key="item.id" cols="12" sm="6" md="4">
        <DamageItem
          :item="item"
          @update="updateItem"
          @remove="removeItem"
          :insurer="insurer"
        />
      </v-col>
    </v-row>

    <!-- ADICIONAR -->
    <v-btn
      outlined
      block
      :color="insurer.color"
      class="mt-3"
      @click="openDialog"
    >
      <v-icon left>mdi-plus</v-icon>
      Adicionar imagem
    </v-btn>

    <!-- DIALOG (APENAS PARA CRIAR NOVO ITEM) -->
    <v-dialog v-model="dialog" max-width="520" persistent>
      <v-card>
        <v-card-title class="d-flex align-center">
          Adicionar dano
          <v-spacer />
          <v-btn icon @click="closeDialog" :disabled="saving">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <div class="mb-3">Selecione uma imagem do dano e descreva.</div>

          <PhotoPicker v-model="form.photo" :src="null" :insurer="insurer" />

          <v-textarea
            class="mt-3"
            v-model="form.description"
            label="Descreva a imagem do dano*"
            placeholder="Ex: Dano na parede da cozinha causada por infiltração."
            outlined
            dense
            :color="insurer.color"
            auto-grow
            rows="3"
          />

          <v-alert v-if="error" dense text type="warning" class="mt-3">
            {{ error }}
          </v-alert>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            block
            :color="insurer.color"
            :disabled="isAddDisabled || saving"
            :dark="!(isAddDisabled || saving)"
            :loading="saving"
            @click="addNewItem"
          >
            Adicionar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import DamageItem from "./DamageItem.vue";
import PhotoPicker from "@/components/customers/PhotoPicker.vue";
import { returnPathImages } from "@/services/customer_inbound";

const STORAGE_KEY = "risk_location_damages";

export default {
  name: "DamageGallery",
  components: { DamageItem, PhotoPicker },

  props: {
    insurer: Object,
  },

  data() {
    return {
      items: [],

      dialog: false,
      saving: false,
      error: null,

      form: {
        photo: null, // File
        description: "",
      },
    };
  },

  computed: {
    isAddDisabled() {
      if (!this.form.photo) return true;
      if (!this.form.description?.trim()) return true;
      return false;
    },
  },

  created() {
    this.loadFromStorage();
  },

  methods: {
    openDialog() {
      this.resetForm();
      this.dialog = true;
    },

    closeDialog() {
      this.resetForm();
      this.dialog = false;
    },

    async addNewItem() {
      this.error = null;
      this.saving = true;

      try {
        const result = await returnPathImages([this.form.photo]);
        const path = result?.paths?.[0];
        if (!path) throw new Error("Path da imagem não retornado");

        this.items.push({
          id: crypto.randomUUID(),
          path,
          description: this.form.description.trim(),
        });

        this.persist();
        this.closeDialog();
      } catch (e) {
        console.error("Erro ao adicionar dano", e);
        this.error = "Erro ao enviar/salvar a imagem. Tente novamente.";
      } finally {
        this.saving = false;
      }
    },

    updateItem(updated) {
      this.items = this.items.map((i) => (i.id === updated.id ? updated : i));
      this.persist();
    },

    removeItem(id) {
      this.items = this.items.filter((i) => i.id !== id);
      this.persist();
    },

    persist() {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(this.items));
    },

    loadFromStorage() {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) {
        this.items = [];
        return;
      }

      try {
        this.items = JSON.parse(raw) || [];
      } catch (e) {
        console.warn("Erro ao carregar danos do storage", e);
        this.items = [];
      }
    },

    resetForm() {
      this.form = { photo: null, description: "" };
      this.error = null;
      this.saving = false;
    },
  },
};
</script>
